import { c as _c } from "react/compiler-runtime";
import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";
import { MotionProvider } from "./providers/motion-provider";
function AnimatePresenceWrapper(t0) {
  const $ = _c(6);
  const {
    children,
    childKey,
    show
  } = t0;
  let t1;
  if ($[0] !== childKey || $[1] !== children || $[2] !== show) {
    t1 = show && <m.div key={childKey} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }}>{children}</m.div>;
    $[0] = childKey;
    $[1] = children;
    $[2] = show;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <MotionProvider><AnimatePresence mode="popLayout">{t1}</AnimatePresence></MotionProvider>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export { AnimatePresenceWrapper };